import React from 'react';
import { CardColor, Card } from '../types';
import { Language } from '../data/translations';
import { ColorDecksDisplay } from '../constants';

interface DeckInfoPanelProps {
  colorDecks: Record<CardColor, Card[]>;
  availableTowers?: CardColor[];
  isDealing: boolean;
  language: Language;
}

const DeckInfoPanel = React.forwardRef<HTMLDivElement, DeckInfoPanelProps>(
  ({ colorDecks, availableTowers, isDealing, language }, ref) => {
    return (
      <div className="relative pointer-events-none">
        {/* 
            The inner div is the actual group and trigger. 
            By setting pointer-events-auto here and having it translated, 
            only the visually rendered part of the panel will intercept 
            mouse/touch events when collapsed.
        */}
        <div className="group transition-transform duration-500 ease-in-out translate-x-[80%] hover:translate-x-0 pointer-events-auto">
          <div ref={ref}>
            <ColorDecksDisplay 
              colorDecks={colorDecks} 
              availableTowers={availableTowers} 
              isDealing={isDealing} 
              language={language} 
            />
          </div>
        </div>
      </div>
    );
  }
);

DeckInfoPanel.displayName = 'DeckInfoPanel';

export default DeckInfoPanel;
